export default __webpack_public_path__ + "static/media/add_photo.37928e72.svg";